import { Box } from '@mui/material'
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import { useQuery, useQueryClient } from 'react-query'
import { removeAdjustedEmployee } from 'services/api/modules/payroll/payroll-view'
import React, { useState } from 'react'

const RemovePayrollModal = ({ deets, time_id, children }) => {
  const [isModalOpen, setModalOpen] = useState(false)
  const handleOpen = () => {
    setModalOpen(true)
  }
  const handleClose = () => {
    setModalOpen(false)
  }
  let employee_id = deets?.id
  const queryClient = useQueryClient()
  const {
    // data: removeEmployeeCalc,
    refetch,
  } = useQuery(
    ['removeAdjustedEmployee', { employee_id, time_id }],
    async () => removeAdjustedEmployee(employee_id, time_id),
    {
      enabled: false,
      onSuccess: () => {
        queryClient.invalidateQueries('retrieveEmployeeData')
        setModalOpen(false)
      },
    }
  )
  const removeCalc = () => {
    refetch()
  }
  return (
    <>
      <Box onClick={handleOpen}>{children}</Box>
      <AdxInfoModal
        variant={'error'}
        open={isModalOpen}
        onClose={handleClose}
        handleClose={handleClose}
        muiIcon="error"
        iconColor="error.main"
        title="Are you sure you want to remove this?"
        subtitle="All the changes will be removed from this payroll period"
        footerButtons
        firstBtnLabel={'Remove'}
        firstBtnHandle={removeCalc}
        secondBtnLabel={'Cancel'}
        secondBtnHandle={handleClose}
      ></AdxInfoModal>
    </>
  )
}
export default RemovePayrollModal
